import { PagingFilter } from '../shared/pagingFilter';

export class UsersFilter extends PagingFilter {
  searchQuery: string | null;

  constructor() {
    super();
  }
}
